import { render, staticRenderFns } from "./DescCard.vue?vue&type=template&id=2d6f165e"
import script from "./DescCard.vue?vue&type=script&lang=ts"
export * from "./DescCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports